import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './assets/styles/animate.css'
import './assets/styles/index.css'
import 'rsuite/dist/styles/rsuite.min.css'
import {isDev} from "./config/config"
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import EadHomePage from './_pages/Account/index'
import Home from './_pages/Home/index'
import CourseDetails from './_pages/CourseDetails/index'
import Admin from './_pages/Admin'
import SalePage from './_pages/Sale'
import BankBillet from './components/BankBillet/BankBillet'
import LoginPage from './_pages/Login'
import EadWatchPage from './_pages/Watch'
import _ from 'lodash'
import MCLoading from "./components/_minha-central/Loading"
import NRTAppContext, {withAppContext} from "./components/_common/AppContext"
import MCErrorMsg from "./components/_common/ErrorMsg"
import MCTopToast from "./components/_common/TopToast"
import ErrorBoundary from "./components/_common/ErrorBoundary"
import {CONTEXT_INITIAL_STATE} from "./constants"
import CredCardConfirmationReturn from "./_pages/Sale/_partials/CredCardConfirmationReturn"
import PersonRequests from "./requests/person-requests"
import tryLogin from "./_functions/try-login"
import RequestV2 from "./helpers/request-v2"
import Request from "./helpers/request"
import {setPrimaryColor, setSecondaryColor} from "./helpers/theme"
import ReleaseRequests from "./requests/release-requests"
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/lib/integration/react'
import createStore from "./redux/create-store"
import FormCardInfo from "./_pages/Sale/_partials/PaymentStep/_components/FormCardInfo"
import CompleteRegistrationPage from "./_pages/CompleteRegistration/page";

const {store, persistor} = createStore()

export class App extends Component {


    state = {
        error: null,
        initFinished: false,
        notEnable: false
    }


    async componentDidMount() {
        this.props.context.set({
            logout: () => this.props.logout(this.props.context),
            logError: isDev ? console.error : this.props.logError,
        })
        await this.initApp()

    }


    async initApp() {


        const {
            getSystemParams,
            getCentralConfig,
            getPaymentPartnerCode,
            checkIfBankBilletIsEnabled,
        } = this.props

        try {
            const credentials = await this.props.getSchema()

            Request.init(credentials)
            RequestV2.init(credentials)

            const schemaInfo = await this.props.schemaInfo()
            const systemParams = await getSystemParams()
            const systemConfig = await getCentralConfig()
            const systemConfigParameterValue = JSON.parse(_.get(systemConfig, 'parameterValue', {})) || {
                publicArea: true,
                sections: [],
                banners: []
            }
            const salePaymentPartnerCodeResult = await getPaymentPartnerCode()
            const salePaymentPartnerCode = _.get(salePaymentPartnerCodeResult, 'parameterValue')
            const bankBilletEnabled = await checkIfBankBilletIsEnabled()

            this.setThemeColors(
                systemConfigParameterValue.primaryColor || "#487eb0",
                systemConfigParameterValue.secondaryColor || "#fa8231"
            )

            this.props.context.set({
                credentials,
                systemParams,
                systemConfig,
                systemConfigParameterValue,
                salePaymentPartnerCode,
                saleBankBilletEnabled: bankBilletEnabled,
                schemaInfo
            }, () => {
                this.setState({initFinished: true})
            })

        } catch (err) {
            this.onError(err, {method: 'initApp()'})
        }


    }


    setThemeColors(primaryColor, secondaryColor) {
        setPrimaryColor(primaryColor)
        setSecondaryColor(secondaryColor)
    }


    onError(error, additionalData = {}) {

        console.log(error)
        this.setState({
            error,
            initFinished: true,
            notEnable: false,
        })


        this.props.logError(
            error,
            {
                login: _.get(this.props, 'context.person.login', ''),
                ...additionalData
            }
        )
    }


    renderPage = (PageComponent, propsFromRouter) => {

        return <PageComponent {...propsFromRouter}
                              context={this.props.context}
                              title={_.get(this.props.context, 'systemConfigParameterValue.title', '')}
        />
    }


    render() {


        if (this.state.error && this.state.notEnable)
            return (
                <MCErrorMsg auxMsg="Entre em contato com nosso suporte para maiores informações.">
                    Minha Central não está habilitada para esse domínio.
                </MCErrorMsg>
            )

        if (this.state.error)
            return (
                <MCErrorMsg>
                    Ocorreu um erro ao buscar os dados da Minha Central.
                </MCErrorMsg>
            )

        if (!this.state.initFinished)
            return (
                <MCLoading/>
            )


        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ErrorBoundary onError={(error, info) => {
                        if (!isDev)
                            this.props.context.logError(error, info)
                    }}>

                        <MCTopToast message={this.props.context.toastMessage}/>

                        <Router>
                            <Switch>
                                <Route path={"/card"} render={props => <FormCardInfo/>}/>
                                <Route path={"/boleto/:ibbCode"}
                                       render={(props) => this.renderPage(BankBillet, props)}
                                />

                                <Route path={'/venda/:releaseCode/:step'}
                                       render={(props) => this.renderPage(SalePage, {
                                           getCourseData: ReleaseRequests.get,
                                           ...props
                                       })}
                                />

                                <Route path={'/completar-cadastro/:releaseCode/:email'}
                                       render={(props) => this.renderPage(CompleteRegistrationPage, props)}
                                />

                                <Route path={'/venda-cartao-confirma'}
                                       render={(props) => this.renderPage(CredCardConfirmationReturn, props)}
                                />

                                <Route path={'/ead/assistir/:accountCode/:userId/:releaseId/:contentId?'}
                                       render={(props) => this.renderPage(EadWatchPage, props)}
                                />

                                <Route path={'/conta/:page?'}
                                       render={(props) => this.renderPage(EadHomePage, props)}
                                />

                                <Route path={'/curso/:id'}
                                       render={(props) => this.renderPage(CourseDetails, props)}
                                />

                                <Route path={'/servico/:id'}
                                       render={(props) => this.renderPage(CourseDetails, props)}
                                />

                                <Route path={'/produto/:id'}
                                       render={(props) => this.renderPage(CourseDetails, props)}
                                />

                                <Route path={'/admin'}
                                       render={(props) => this.renderPage(Admin, props)}
                                />

                                <Route path={'/login/:step'}
                                       render={(props) => this.renderPage(LoginPage, {
                                           ...props,
                                           tryLogin: tryLogin(PersonRequests.search)
                                       })}
                                />

                                <Route path={'/'}
                                       render={(props) => this.renderPage(Home, props)}
                                />

                            </Switch>
                        </Router>
                    </ErrorBoundary>
                </PersistGate>
            </Provider>
        )
    }
}

App.propTypes = {
    getSchema: PropTypes.func.isRequired,
    schemaInfo: PropTypes.func.isRequired,
    getSystemParams: PropTypes.func.isRequired,
    getCentralConfig: PropTypes.func.isRequired,
    getPaymentPartnerCode: PropTypes.func.isRequired,
    checkIfBankBilletIsEnabled: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    logError: PropTypes.func.isRequired,
}

const AppWithContext = withAppContext(App)


const MinhaCentralApp = (props) => (

    <NRTAppContext
        initialState={CONTEXT_INITIAL_STATE}
        keysToPersist={[
            'person',
            'isTeacher'
        ]}
        debug={false}>

        <AppWithContext {...props}/>
    </NRTAppContext>
)

MinhaCentralApp.displayName = 'App'


export default MinhaCentralApp



// WEBPACK FOOTER //
// ./src/App.js